import axios from "axios";
import {getOptions} from "../../helpers/api";

export const dashboard = {

  getScopeYears: (data) => {
    const {params, headers} = getOptions(data);
    return axios.post("/ntww_odp/scope/years", params, headers);
  },

  getMenuList: (data) => {
    const {params, headers} = getOptions(data);
    return axios.post("/ntww_odp/menu/list", params, headers);
  },

  getExchangeSystems: (data) => {
    const {params, headers} = getOptions(data);
    return axios.post("/ntww_odp/exchange/systems", params, headers);
  },

  getRegion: (data) => {
    const {params, headers} = getOptions(data);
    return axios.post("/ntww_odp/region", params, headers);
  },

  getSites: (data) => {
    const {params, headers} = getOptions(data);
    return axios.post("/ntww_odp/sites", params, headers);
  },

  getActivities: (data) => {
    const {params, headers} = getOptions(data);
    return axios.post("/ntww_odp/activities", params, headers);
  },

  getFieldTasks: (data) => {
    const {params, headers} = getOptions(data);
    return axios.post("/ntww_odp/fieldtasks", params, headers);
  },

  getForecasts: (data) => {
    const {params, headers} = getOptions(data);
    return axios.post("/ntww_odp/forecast", params, headers);
  },

  getBTS: (data) => {
    const {params, headers} = getOptions(data);
    return axios.post("/ntww_odp/bts", params, headers);
  },

  getContracts: (data) => {
    const {params, headers} = getOptions(data);
    return axios.post("/ntww_odp/contract", params, headers);
  },

  getPermits: (data) => {
    const {params, headers} = getOptions(data);
    return axios.post("/ntww_odp/permit", params, headers);
  },

  getInvoices: (data) => {
    const {params, headers} = getOptions(data);
    return axios.post("/ntww_odp/invoice", params, headers);
  },

};